const accordions = document.querySelectorAll( '.accordion' );

accordions?.forEach( ( item ) => {
	item.addEventListener( 'click', () => {
		const content = item.querySelector( '.accordion-content' );
		item.classList.toggle( 'open' );
		if ( item.classList.contains( 'open' ) ) {
			content.style.height = `${ content.scrollHeight }px`;
		} else {
			content.style.height = '0';
		}
	} );
} );
